// @ts-strict-ignore
import {Component} from "@angular/core";
import {AbstractModal} from "src/app/shared/components/modal/abstractModal";
import {ChannelAddress, Currency, CurrentData, EdgeConfig} from "src/app/shared/shared";

@Component({
  templateUrl: "./modal.html",
  standalone: false,
})
export class ModalComponent extends AbstractModal {

  protected consumptionPriceWithCurrency: string;
  protected productionPriceWithCurrency: string;

  protected override getChannelAddresses(): ChannelAddress[] {
    return [
      new ChannelAddress(this.component.id, "QuarterlyConsumptionPrices"),
      new ChannelAddress(this.component.id, "QuarterlyProductionPrices"),
    ];
  }


  protected override onCurrentData(currentData: CurrentData): void {
    const quarterlyConsumptionPrice = currentData.allComponents[this.component.id + "/QuarterlyConsumptionPrices"];
    const quarterlyProductionPrice = currentData.allComponents[this.component.id + "/QuarterlyProductionPrices"];
    const meta: EdgeConfig.Component = this.config?.getComponent("_meta");
    const currency: string = this.config?.getPropertyFromComponent<string>(meta, "currency");
    const currencyLabel: Currency.Label = Currency.getCurrencyLabelByCurrency(currency);
    this.consumptionPriceWithCurrency = this.Utils.CONVERT_PRICE_TO_CENT_PER_KWH(2, currencyLabel)(quarterlyConsumptionPrice);
    this.productionPriceWithCurrency = this.Utils.CONVERT_PRICE_TO_CENT_PER_KWH(2, currencyLabel)(quarterlyProductionPrice);
  }
}
